import React, { useState } from "react";
import "./BulkCreation.scss";
import remove from "../../../../static/images/remove.png";
import checkGreen from "../../../../static/images/checkGreen.png";
import { Field } from "redux-form";
import { FormElems } from "../../../../components";

const BulkUpload = ({ handleCloseModal, isOpen }) => {
    const [uploadSuccess, setUploadSuccess] = useState(false);

    // Prevent rendering if modal is not open
    if (!isOpen) return null;

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();
        console.log("Form submitted!");
        setUploadSuccess(true);
    };

    return (
        <div className="modal-overlay bulk-modal">
            <div className="modal-content bulk-modal">
                <div className="modal-header">
                    <h2>Terminal Bulk Generate</h2>
                    <div>
                        <img
                            src={remove}
                            alt="Close"
                            onClick={() => {
                                handleCloseModal();
                                setUploadSuccess(false);
                            }}
                        />
                    </div>
                </div>

                {uploadSuccess ? (
                    <div className="success-message">
                        <div className="success-icon">
                            <img src={checkGreen} alt="Success" />
                        </div>
                        <h1>Requested Terminal IDs generated successfully</h1>
                        <p>Please visit Terminal Onboarding to see detailed info</p>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <ul className="bulk-upload-form">
                            {/* Dealer Email */}
                            <li className="form-section2" key="email">
                                <div className="form-field">
                                    <p className="label">TID Prefix</p>
                                    <FormElems.Input
                                        name="dealerEmail1"
                                        type="text"
                                        id="dealer-email-1"
                                        placeholder="TID Prefix"
                                    />
                                </div>
                            </li>

                            {/* Dealer Name */}
                            <li className="form-section2" key="name">
                                <div className="form-field">
                                    <p className="label">TID Count (MAX 10000)</p>
                                    <FormElems.Input
                                        name="TID Count"
                                        type="text"
                                        id="dealer-name"
                                        placeholder="Enter TID Count"
                                    />
                                </div>
                            </li>

                            {/* Dealer Contact */}
                            <li className="form-section2" key="contact">
                                <div className="form-field">
                                    <p className="label">Settlement Account</p>
                                    <FormElems.Select
                                        name="dealerContact"
                                        type="text"
                                        id="dealer-contact"
                                        placeholder="Select Settlement Account"
                                        defaultValue="select_settlement"
                                        data={[
                                            {
                                                value: 'select_settlement',
                                                label: 'Select Settlement Account',
                                            },
                                            {
                                                value: '121544234',
                                                label: '121544234',
                                            },
                                            {
                                                value: '54647647474',
                                                label: '54647647474',
                                            },
                                            {
                                                value: '3775336676327',
                                                label: '3775336676327',
                                            },
                                        ]}
                                        valueField={'value'}
                                        labelField={'label'}
                                    />
                                </div>
                            </li>
                        </ul>

                        {/* Submit Button */}
                        <div className="form-footer">
                            <button type="submit" className="submit-btn">
                                Submit
                            </button>
                        </div>
                    </form>
                )
                }

            </div>
        </div>
    );
};

export default BulkUpload;
